import { dispatch, withSelect } from "@wordpress/data";
import React, { useState, useEffect } from "react";
import {
  size,
  map,
  forEach,
  get,
  has,
  isArray,
  filter,
  find,
  mapValues,
} from "lodash";
import classnames from "classnames";

import { saveTracks } from "../helpers/save-tracks";

import "./bulkEditBar.scss";

function BulkEditModal({ children, className }) {
  return (
    <div className={classnames("bulkEditModal", className)}>
      <div className="bulkEditModal__inner">{children}</div>
    </div>
  );
}

function MultiSelectList({
  selectedTracks,
  options,
  property,
  propertyDisplay,
  multiple = true,
  closeModal,
}) {
  const [selected, setSelected] = useState({});
  const [dirtyItemsCount, setDirtyItemsCount] = useState(0);

  console.log("property");
  console.log(property);

  console.log("Array.isArray(property)");
  console.log(Array.isArray(property));

  let optionsInUse = {};
  // Only set this up like this for multiple mode.
  if (multiple) {
    forEach(selectedTracks, (selectedTrack) => {
      console.log("selectedTrack");
      console.log(selectedTrack);

      let propertyValue;
      if (Array.isArray(property)) {
        propertyValue = map(property, (_property) => {
          return get(selectedTrack, [_property]);
        });
      } else {
        propertyValue = get(selectedTrack, [property]);
      }

      console.log("propertyValue");
      console.log(propertyValue);

      console.log("isArray(propertyValue)");
      console.log(isArray(propertyValue));

      if (isArray(propertyValue)) {
        forEach(propertyValue, (propertyValueItem) => {
          console.log("propertyValueItem");
          console.log(propertyValueItem);

          const propertyValueItems = isArray(propertyValueItem)
            ? propertyValueItem
            : [propertyValueItem];

          forEach(propertyValueItems, (_propertyValueItem) => {
            if (!has(optionsInUse, [_propertyValueItem])) {
              optionsInUse[_propertyValueItem] = 0;
            }

            // increment
            optionsInUse[_propertyValueItem] =
              optionsInUse[_propertyValueItem] + 1;
          });
        });
      } else {
        console.log("propertyValue is a string!! TODO");
        debugger;
      }
    });
  }

  console.log("optionsInUse");
  console.log(optionsInUse);

  const selectedTracksCount = size(selectedTracks);

  useEffect(() => {
    forEach(options, (option) => {
      // default is un-checked, like for non-multiple mode.
      let value = "un-checked";

      // Only set this up like this for multiple mode.
      if (multiple) {
        if (has(optionsInUse, [option.name])) {
          if (selectedTracksCount === optionsInUse[option.name]) {
            value = "checked";
          } else {
            value = "semi-checked";
          }
        }
      }

      const updatedValues = {
        ...selected,
        [option.name]: {
          option,
          dirty: false,
          original: value,
          value: value,
        },
      };

      setSelected((prevState) => {
        return { ...prevState, ...updatedValues };
      });
    });
  }, []); // blank 2nd arg so it only runs once, on init.

  useEffect(() => {
    const dirtyItems = filter(selected, (i) => i.dirty);

    setDirtyItemsCount(size(dirtyItems));
  }, [selected]);

  return (
    <div className="multiSelectList">
      {/* <div className="multiSelectHeader__wrap">
        <h3>
          Set {propertyDisplay} for these {size(selectedTracks)} tracks
        </h3>
      </div> */}
      <div className="multiSelectList__wrap">
        <ul className="multiSelectList__list">
          {/* {!multiple && <li key="clear">Clear {property} from all Tracks.</li>} */}
          {map(options, (option) => {
            let indicator = null;
            let className = "";
            const currentValue = get(selected, [option.name, "value"], "");

            if ("checked" === currentValue) {
              className = "multiSelectList__item__checkbox--checked";
              indicator = <span>✓</span>;
            } else if ("semi-checked" === currentValue) {
              className = "multiSelectList__item__checkbox--semi-checked";
              indicator = <span>‐</span>;
            }

            return (
              <li key={option.id} className="multiSelectList__item">
                <div
                  className={classnames(
                    "multiSelectList__item__checkbox",
                    className
                  )}
                  onClick={() => {
                    const currentValue = selected[option.name];

                    let newValue = "";
                    if ("checked" === currentValue.value) {
                      newValue = "un-checked";
                    } else if ("un-checked" == currentValue.value) {
                      newValue = "checked";
                    } else if ("semi-checked" == currentValue.value) {
                      newValue = "checked";
                    }

                    // clone it so we can begin to mutate the copy.
                    let updatedValues = { ...selected };

                    // if non-mulitple mode, and this item is checked, uncheck all others.
                    if (!multiple && "checked" === newValue) {
                      updatedValues = mapValues(
                        updatedValues,
                        (value, key) => ({
                          ...value,
                          dirty: false,
                          value:
                            "checked" === value.value
                              ? "un-checked"
                              : value.value,
                        })
                      );
                    }

                    // udpate this option's values.
                    updatedValues[option.name] = {
                      ...currentValue,
                      dirty: newValue !== currentValue.original,
                      value: newValue,
                    };

                    setSelected((prevState) => {
                      // Object.assign would also work
                      return { ...prevState, ...updatedValues };
                    });

                    console.log("updated selected");
                    console.log(selected);
                  }}
                >
                  {indicator}
                </div>
                <div className="multiSelectList__item__label">
                  {option.name}
                </div>
              </li>
            );
          })}
        </ul>
      </div>
      {dirtyItemsCount > 0 && (
        <div className="multiSelectSummary__wrap">
          <p>Set {propertyDisplay} to: </p>
          <ul>
            {filter(selected, (i) => {
              if (i.dirty) {
                // if not multiple use the only 1 checked item
                if (!multiple && "checked" === i.value) {
                  return true;
                }

                // if multiple, always return true for all dirty values
                return true;
              }

              return false;
            }).map((dirtyItem, key) => {
              let prefix = "";
              if (multiple) {
                if ("checked" === dirtyItem.value) {
                  prefix = "Add ";
                }

                if ("un-checked" === dirtyItem.value) {
                  prefix = "Remove ";
                }
              }

              return <li key={key}>{`${prefix}${dirtyItem.option.name}`}</li>;
            })}
          </ul>
        </div>
      )}
      <div className="multiSelectFooter__wrap">
        <button onClick={closeModal}>Cancel</button>
        {dirtyItemsCount > 0 && (
          <button
            onClick={() => {
              // console.log("selectedTracks");
              // console.log(selectedTracks);
              // console.log("selected");
              // console.log(selected);
              const checkedValues = filter(selected, (i) => {
                if (i.dirty) {
                  // if not multiple use the only 1 checked item
                  if (!multiple && "checked" === i.value) {
                    return true;
                  }

                  // if multiple, always return true for all dirty values
                  return true;
                }
              });

              let tracks = [];

              if (multiple) {
                const findIdFromAlgoliaValue = (textValue) => {
                  return find(options, (option) => {
                    return textValue === option.name;
                  }).id;
                };

                console.log("multiple values!");

                let properties = Array.isArray(property)
                  ? property
                  : [property];

                // id based to update WP with
                const valuesToAdd = {};
                const valuesToRemove = {};

                // text based to update internal store algolia shaped data with
                const algoliaValuesToAdd = {};
                const algoliaValuesToRemove = {};

                properties.forEach((_property) => {
                  // id based to update WP with
                  valuesToAdd[_property] = [];
                  valuesToRemove[_property] = [];

                  // text based to update internal store algolia shaped data with
                  algoliaValuesToAdd[_property] = [];
                  algoliaValuesToRemove[_property] = [];
                });

                console.log("checkedValues");
                console.log(checkedValues);

                checkedValues.forEach((dirtyItem, key) => {
                  console.log("dirtyItem");
                  console.log(dirtyItem);

                  let _property = get(dirtyItem, "option.field", property);

                  if ("checked" === dirtyItem.value) {
                    valuesToAdd[_property].push(dirtyItem.option.id);
                    algoliaValuesToAdd[_property].push(dirtyItem.option.name);
                  }

                  if ("un-checked" === dirtyItem.value) {
                    valuesToRemove[_property].push(dirtyItem.option.id);
                    algoliaValuesToRemove[_property].push(
                      dirtyItem.option.name
                    );
                  }
                });

                console.log("valuesToAdd");
                console.log(valuesToAdd);
                console.log("algoliaValuesToAdd");
                console.log(algoliaValuesToAdd);

                console.log("valuesToRemove");
                console.log(valuesToRemove);
                console.log("algoliaValuesToRemove");
                console.log(algoliaValuesToRemove);

                forEach(selectedTracks, (selectedTrack) => {
                  console.log("selectedTrack");
                  console.log(selectedTrack);

                  const newValues = {};
                  const newAlgoliaValues = {};
                  properties.forEach((_property) => {
                    newValues[_property] = [];
                    newAlgoliaValues[_property] = [];
                  });
                  properties.forEach((_property) => {
                    const existingValues = selectedTrack[_property];

                    console.log("existingValues");
                    console.log(existingValues);

                    existingValues.forEach((existingValue) => {
                      if (
                        !algoliaValuesToRemove[_property].includes(
                          existingValue
                        )
                      ) {
                        newValues[_property].push(
                          findIdFromAlgoliaValue(existingValue)
                        );
                        newAlgoliaValues[_property].push(existingValue);
                      }
                    });

                    algoliaValuesToAdd[_property].forEach(
                      (algoliaValueToAdd) => {
                        if (!existingValues.includes(algoliaValueToAdd)) {
                          newValues[_property].push(
                            findIdFromAlgoliaValue(algoliaValueToAdd)
                          );
                          newAlgoliaValues[_property].push(algoliaValueToAdd);
                        }
                      }
                    );
                  });

                  console.log("newValues");
                  console.log(newValues);

                  console.log("newAlgoliaValues");
                  console.log(newAlgoliaValues);

                  tracks.push({
                    id: selectedTrack.objectID,
                    property: properties, // todo... properties?
                    value: newValues, // newValues keyed to each property?
                    algoliaValue: newAlgoliaValues,
                  });
                });
              } else {
                // id based to update WP with
                const newValues = checkedValues.map((dirtyItem, key) => {
                  return dirtyItem.option.id;
                });

                // text based to update internal store algolia shaped data with
                const newAlgoliaValues = checkedValues.map((dirtyItem, key) => {
                  return dirtyItem.option.name;
                });

                forEach(selectedTracks, (selectedTrack) => {
                  tracks.push({
                    id: selectedTrack.objectID,
                    property,
                    value: newValues[0],
                    algoliaValue: newAlgoliaValues[0],
                  });
                });
              }

              console.log("tracks would have been saved");
              console.log(tracks);
              saveTracks(tracks, closeModal);
            }}
          >
            Apply Changes
          </button>
        )}
      </div>
    </div>
  );
}

function EditArtist({ selectedTracks, closeModal }) {
  return (
    <BulkEditModal>
      <h3>
        Set Artist for {size(selectedTracks)}{" "}
        {size(selectedTracks) > 1 ? "tracks" : "track"}
      </h3>

      <MultiSelectList
        options={window.HIFI_APP.artists}
        selectedTracks={selectedTracks}
        property="artist"
        propertyDisplay="Artist"
        multiple={false}
        closeModal={closeModal}
      />
    </BulkEditModal>
  );
}

function EditKeywords({ selectedTracks, closeModal }) {
  return (
    <BulkEditModal>
      <h3>
        Set Keywords for {size(selectedTracks)}{" "}
        {size(selectedTracks) > 1 ? "tracks" : "track"}
      </h3>

      <MultiSelectList
        options={window.HIFI_APP.keywords}
        selectedTracks={selectedTracks}
        property="keyword"
        propertyDisplay="Keyword"
        closeModal={closeModal}
      />
    </BulkEditModal>
  );
}

function EditPrimaryInstrument({ selectedTracks, closeModal }) {
  return (
    <BulkEditModal>
      <h3>
        Set Primary Instrument for {size(selectedTracks)}{" "}
        {size(selectedTracks) > 1 ? "tracks" : "track"}
      </h3>

      <MultiSelectList
        options={window.HIFI_APP.primary_instruments}
        selectedTracks={selectedTracks}
        property="primary-instrument"
        propertyDisplay="Primary Instrument"
        multiple={false}
        closeModal={closeModal}
      />
    </BulkEditModal>
  );
}

function EditGenres({ selectedTracks, closeModal }) {
  return (
    <BulkEditModal>
      <h3>
        Set Genre for {size(selectedTracks)}{" "}
        {size(selectedTracks) > 1 ? "tracks" : "track"}
      </h3>

      <MultiSelectList
        options={window.HIFI_APP.genres}
        selectedTracks={selectedTracks}
        property={["genre.lvl0", "genre.lvl1"]}
        propertyDisplay="Genre"
        closeModal={closeModal}
      />
    </BulkEditModal>
  );
}

function EditStatus({ selectedTracks, closeModal }) {
  const statusOptions = [
    {
      name: "publish",
      id: "pubish",
    },
    {
      name: "draft",
      id: "draft",
    },
    {
      name: "pending",
      id: "pending",
    },
  ];

  return (
    <BulkEditModal className="bulkEditModal--status">
      <h3>
        Set Status for {size(selectedTracks)}{" "}
        {size(selectedTracks) > 1 ? "tracks" : "track"}
      </h3>

      <MultiSelectList
        options={statusOptions}
        selectedTracks={selectedTracks}
        property="status"
        propertyDisplay="Status"
        multiple={false}
        closeModal={closeModal}
      />
    </BulkEditModal>
  );
}

function bulkEditBar({ selectedTracks }) {
  const [selected, setSelected] = useState("");
  const [opSelected, setOpSelected] = useState([]);
  const { removeAllFromSelected } = dispatch("hifi");

  if (!size(selectedTracks)) {
    return null;
  }

  return (
    <div>
      <div>
        {"artist" === selected && (
          <EditArtist
            selectedTracks={selectedTracks}
            closeModal={() => setSelected("")}
          />
        )}
        {"keyword" === selected && (
          <EditKeywords
            selectedTracks={selectedTracks}
            closeModal={() => setSelected("")}
          />
        )}
        {"genre" === selected && (
          <EditGenres
            selectedTracks={selectedTracks}
            closeModal={() => setSelected("")}
          />
        )}
        {"primary-instrument" === selected && (
          <EditPrimaryInstrument
            selectedTracks={selectedTracks}
            closeModal={() => setSelected("")}
          />
        )}
        {"shape" === selected && (
          <EditShape
            selectedTracks={selectedTracks}
            closeModal={() => setSelected("")}
          />
        )}
        {"status" === selected && (
          <EditStatus
            selectedTracks={selectedTracks}
            closeModal={() => setSelected("")}
          />
        )}
      </div>
      <div className="bulkEditBar bulkEditBar__wrap">
        <div className="bulkEditBar__inner">
          {/* <div className=""> */}
          <div className="bulkEditBar__qty_selected">
            <h3>
              {size(selectedTracks)}{" "}
              {size(selectedTracks) > 1 ? "Tracks" : "Track"} Selected
            </h3>
            {/* <div> */}
            <button className="clear-btn" onClick={removeAllFromSelected}>
              Clear ×
            </button>
            {/* </div> */}
          </div>
          <div className="bulkEditBar__fields">
            {/* Artist */}
            <div className="bulkEditBar__field">
              <button
                onClick={() => {
                  setSelected("artist");
                }}
              >
                Set Artist
              </button>
            </div>
            {/* Genre */}
            <div className="bulkEditBar__field">
              <button
                onClick={() => {
                  setSelected("genre");
                }}
              >
                Set Genre
              </button>
            </div>
            {/* Primary Instrument */}
            <div className="bulkEditBar__field">
              <button
                onClick={() => {
                  setSelected("primary-instrument");
                }}
              >
                Set Primary Instrument
              </button>
            </div>
            {/* Keywords */}
            <div className="bulkEditBar__field">
              <button
                onClick={() => {
                  setSelected("keyword");
                }}
              >
                Set Keywords
              </button>
            </div>
            {/* Energy */}
            {/* <div className="bulkEditBar__field">
              <button
                onClick={() => {
                  setSelected("energy");
                }}
              >
                Set Energy
              </button>
            </div> */}
            {/* BPM */}
            {/* <div className="bulkEditBar__field">BPM</div> */}
            {/* Shape */}
            <div className="bulkEditBar__field">
              <button
                onClick={() => {
                  setSelected("shape");
                }}
              >
                Set Shape
              </button>
            </div>
            {/* Customizable */}
            {/* <div className="bulkEditBar__field">Customizable</div> */}
            {/* Status */}
            <div className="bulkEditBar__field">
              <button
                onClick={() => {
                  setSelected("status");
                }}
              >
                Set Status
              </button>
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
}

const BulkEditBar = withSelect((select) => {
  const { getSelectedTracks } = select("hifi");

  return {
    selectedTracks: getSelectedTracks(),
  };
})(bulkEditBar);

export default BulkEditBar;
